import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IconProps } from './types'

/**
 * App-wide icon. Wraps a Font Awesome Pro duotone glyph so QuickPass uses a
 * consistent, professional icon set instead of emoji. Inherits the current
 * text colour by default (duotone renders the secondary layer at reduced
 * opacity); pass `size`/`color` to override, and `label` when the icon
 * conveys meaning on its own (otherwise it's hidden from screen readers).
 *
 * @param {IconProps} props
 * @returns {JSX.Element}
 */
const Icon = ({ icon, size, color, label }: IconProps): JSX.Element => {
  const hasStyle = size !== undefined || color !== undefined

  return (
    <FontAwesomeIcon
      icon={icon}
      fixedWidth
      style={hasStyle ? { fontSize: size, color } : undefined}
      role={label !== undefined ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
    />
  )
}

export default Icon
